export function TermsPage() {
  return (
    <div className="legal-site">
      <header className="legal-header">
        <a href="/" aria-label="Stalkie home">Stalkie</a>
        <span>Terms</span>
      </header>
      <main className="legal-main">
        <div className="legal-heading">
          <p>Legal and access</p>
          <h1>Terms of Use</h1>
          <span>The rules for using Stalkie and managing a subscription.</span>
        </div>

        <article className="legal-document">
          <p>
            <strong>Last updated:</strong> March 14, 2026
          </p>
          <p>By downloading or using Stalkie, you agree to these Terms of Use.</p>
          <p>If you do not agree, do not use the app.</p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8">Service overview</h2>
          <p>
            Stalkie helps people monitor changes on Instagram accounts, such as
            follow and unfollow events.
          </p>
          <p>
            Stalkie operates using information from public Instagram profiles and
            related public activity data made available to the service.
          </p>
          <p>
            Stalkie is not affiliated with, sponsored by, or endorsed by Instagram
            or Meta.
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8">Eligibility</h2>
          <p>
            You must have legal capacity to accept these terms and use the app
            according to applicable laws.
          </p>
          <p>You are responsible for device security and activity on your account.</p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8">Subscription terms</h2>
          <p>Some features require a paid subscription.</p>
          <p>
            For the mobile app, subscriptions are billed and managed through Apple
            App Store and Google Play, with RevenueCat used for subscription
            infrastructure. Web subscriptions are billed and managed through
            Stripe Checkout and Customer Portal.
          </p>
          <p>
            Prices, billing periods, renewals, cancellations, and refunds follow
            the rules of the store or billing provider where the subscription was
            made. Deleting the app does not cancel an active mobile subscription,
            and closing the browser does not cancel a web subscription.
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8">Acceptable use</h2>
          <p>You agree not to:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>use the app for illegal activity, harassment, or abuse;</li>
            <li>attempt to bypass technical limits or security controls;</li>
            <li>run abusive automation against the service;</li>
            <li>interfere with app operations or third-party systems.</li>
          </ul>
          <p>Stalkie may suspend or terminate access for violations.</p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8">Availability</h2>
          <p>
            Stalkie may add, change, pause, or remove features at any time,
            including to meet legal, security, or provider requirements.
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8">Third-party services</h2>
          <p>
            The app relies on third-party services to operate (such as
            infrastructure, payments, notifications, and diagnostics). Those
            services may change over time.
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8">Intellectual property</h2>
          <p>
            The app&apos;s code, branding, design, and content are protected by
            intellectual property laws unless stated otherwise.
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8">
            Disclaimer and limitation of liability
          </h2>
          <p>The service is provided &quot;as is&quot; and &quot;as available.&quot;</p>
          <p>
            Stalkie does not guarantee uninterrupted service, perfect accuracy, or
            error-free operation.
          </p>
          <p>
            Stalkie is not responsible for actions taken by Instagram, Meta, or any
            third-party platform that may affect access to public data or the
            operation of the service. You use the app at your own risk.
          </p>
          <p>
            To the fullest extent allowed by law, Stalkie is not liable for
            indirect, incidental, special, or consequential damages, including data
            loss, business interruption, lost profits, or consequences to
            third-party accounts.
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8">Privacy</h2>
          <p>
            Use of the app is also governed by the{" "}
            <a href="/privacy" className="text-rose-500 font-semibold">
              Privacy Policy
            </a>
            .
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8">Changes to these terms</h2>
          <p>
            Stalkie may update these Terms of Use. Updates are posted on this page
            with a new &quot;Last updated&quot; date.
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8">Contact</h2>
          <p>For questions about these terms:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>
              <strong>Company/Responsible Party:</strong> Stalkie
            </li>
            <li>
              <strong>Email:</strong>{" "}
              <a href="mailto:support@stalkie.app" className="text-rose-500 font-semibold">
                support@stalkie.app
              </a>
            </li>
            <li>
              <strong>Website:</strong>{" "}
              <a href="https://stalkie.app" className="text-rose-500 font-semibold">
                https://stalkie.app
              </a>
            </li>
          </ul>
        </article>
      </main>
      <footer className="legal-footer"><span>© Stalkie</span><a href="/privacy">Privacy Policy</a></footer>
    </div>
  );
}
